import React, { useState, useContext } from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { ViewerContext } from 'four-nets/user/viewer/viewer';

import ImageTitleForm from './image-title-form';
import defaultStyles from './image-title.scss';

interface Props {
    styles: typeof defaultStyles;
    id: string;
    title: string | null;
    postUserUsername?: string | null;
}

const ImageTitle: React.FC<Props> = props => {
    const { styles, id, title, postUserUsername } = props;

    const [editMode, setEditMode] = useState(false);

    const { viewer } = useContext(ViewerContext);
    const isImageAuthor = viewer && postUserUsername === viewer.username;
    const [showingFullContent, setShowingFullContent] = useState(false);

    const showMore = showingFullContent ? (
        <div onClick={() => setShowingFullContent(false)}>
            <FormattedMessage id='BUTTON_SHOW_LESS' />
        </div>
    ) : (
        <div onClick={() => setShowingFullContent(true)}>
            <FormattedMessage id='BUTTON_SHOW_MORE' />
        </div>
    );

    const titleSplitted = title ? title.split(' ') : [];
    const titleShouldBeTrimmed = title ? titleSplitted.length > 30 : false;
    const titleToShow =
        title && titleShouldBeTrimmed && showingFullContent === false
            ? titleSplitted.slice(0, 30).join(' ') + '...'
            : title;

    return (
        <div className={styles.imageTitle}>
            {editMode && isImageAuthor ? (
                <ImageTitleForm id={id} title={title} close={() => setEditMode(false)} />
            ) : (
                <>
                    <span>{titleToShow}</span>
                    {titleShouldBeTrimmed && <div className={styles.expandButton}>{showMore}</div>}
                    {isImageAuthor ? (
                        <div className={classnames(styles.buttons, styles.justifyStart)}>
                            <button onClick={() => setEditMode(prev => !prev)} className={styles.button}>
                                {title ? (
                                    <FormattedMessage id='EDIT_IMAGE_TITLE' />
                                ) : (
                                    <FormattedMessage id='ADD_IMAGE_DESCRIPTION' />
                                )}
                            </button>
                        </div>
                    ) : null}
                </>
            )}
        </div>
    );
};

export default Styled(defaultStyles)(ImageTitle);
